import { api } from "../../api";
import { handleResponse, RequestOptions } from "../types";
import { getCookie } from "../../helpers/utils";
import { cookieToken } from "../../constants";
import { payloadList } from "../../store/agent/transactions";

const getList = (data: payloadList)  => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.cashier.transactionsHistory.list;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};
export const transactionService = {
  getList,
};
